import{a as e}from"./chunk-RAAYCPUM.js";function t(...n){return e(o,n)}var o=n=>n.length===1?n[0]:void 0;export{t as a};
